module.exports = __webpack_public_path__ + "assets/img/A-9bb8ac1a.png";